import { PointsService } from '../points.service'
import { BuilderService } from 'src/app/builder-services/builder.service'
import { CategoriesService } from 'src/app/e-commerce/categories/categories.service'
import { Component, OnInit, ViewChild } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { MatPaginator, PageEvent } from '@angular/material/paginator'
import { MatTableDataSource } from '@angular/material/table'
import { ProductsService } from 'src/app/e-commerce/products/products.service'
import { ActivatedRoute, Router } from '@angular/router'
import { VendorService } from 'src/app/multivendor/vendor.service'
export interface Product {
  imageUrl?: string[]
  productName: string
  productSKU: string
  productStock: number
  salePrice?: string
  regularPrice: string
  date?: string
  checked?: boolean
}
@Component({
  selector: 'app-points',
  templateUrl: './points.component.html',
  styleUrls: ['./points.component.scss']
})
export class PointsComponent implements OnInit {
  @ViewChild(MatPaginator) paginator!: MatPaginator
  @ViewChild('categoryPaginator') categoryPaginator!: MatPaginator
  categories: any[] = []
  dataSource = new MatTableDataSource<any>([])
  searchText: string = ''
  displayedColumns: string[] = ['image', 'productName', 'productSKU', 'productStock', 'price', 'date', 'points']
  points!: FormGroup
  saving = false
  products: any[] = []
  filteredProducts: any[] = []
  selectedCategories: any[] = []
  selectedProducts: MatTableDataSource<any> = new MatTableDataSource<any>()
  selectedProductSet = new Set<any>()
  isEditable = false
  currentSetupId: string | null = null
  currentSystemUuid: string | null = null
  displayedProducts: Product[] = []
  pageSize = 5
  pageIndex = 0
  totalProducts = 0
  displayedCategories: any[] = []
  categoryPageSize = 5
  categoryPageIndex = 0
  totalCategories = 0
  project_id: string | undefined
  constructor(private route: ActivatedRoute, private router: Router, public builderService: BuilderService, private categoriesService: CategoriesService, private fb: FormBuilder, public productService: ProductsService, public vendor: VendorService, private pointsService: PointsService) {
    this.project_id = this.builderService.selectedProject
  }

  /*
  The `checkAll` function handles the selection of all products based on the checkbox state.

  1. If the checkbox is checked:
     - Iterates through all products and sets their `checked` property to `true`.
     - Updates the `selectedProductSet` to include all products in the `dataSource`.

  2. If the checkbox is unchecked:
     - Iterates through all products and sets their `checked` property to `false`.
     - Clears the `selectedProductSet`.

  3. Updates the `selectedProducts` data array with the current selection from the `selectedProductSet`.
*/

  checkAll(event: any): void {
    if (event.checked) {
      this.displayedProducts.forEach((product) => (product.checked = true))
      this.displayedProducts.forEach((product) => this.selectedProductSet.add(product))
    } else {
      this.displayedProducts.forEach((product) => (product.checked = false))
      this.displayedProducts.forEach((product) => this.selectedProductSet.delete(product))
    }
    this.selectedProducts.data = Array.from(this.selectedProductSet)
  }

  ngOnInit(): void {
    this.builderService.headerBtn = 'points'
    this.currentSetupId = this.route.snapshot.paramMap.get('id')

    if (this.currentSetupId && this.currentSetupId !== ':id') {
      // We are editing an existing Points setup
      this.loadExistingPointsSetup(this.currentSetupId)
    } else {
      this.getData()
      // We are creating a NEW Points setup
      // Possibly load default form data, or leave everything blank
    }
    this.createForm()
    this.loadData()
  }
  /**
   * Loads existing points setup data from the database and updates the form.
   * @param setupId - The ID of the points setup to retrieve.
   */
  private loadExistingPointsSetup(setupId: string): void {
    this.pointsService.getPointsSystem(setupId)
      .then((data) => {
        if (data) {
          this.currentSystemUuid = data.id
          this.updateFormFields(data)
        }
      })
      .catch((error) => console.error('Error fetching setup data', error))
  }

  /*
  The `onItemChecked` function manages the selection of items based on their type (product or category) and checkbox state.

  1. Updates the `checked` property of the item based on the checkbox state (`event.checked`).

  2. For items of type `product`:
     - If checked, adds the item to the `selectedProductSet`.
     - If unchecked, removes the item from the `selectedProductSet`.
     - Updates the `selectedProducts` data array with the current selection from the `selectedProductSet`.

  3. For items of type `category`:
     - If checked, adds the item to the `selectedCategories` array.
     - If unchecked, removes the item from the `selectedCategories` array based on `categoryId`.
     - Logs the current list of selected categories to the console.
*/

  onItemChecked(item: any, event: any, type: string): void {
    item.checked = event.checked

    if (type === 'product') {
      if (event.checked) {
        this.selectedProductSet.add(item)
      } else {
        this.selectedProductSet.delete(item)
      }
      this.selectedProducts.data = Array.from(this.selectedProductSet)
    } else if (type === 'category') {
      if (event.checked) {
        this.selectedCategories.push(item)
      } else {
        this.selectedCategories = this.selectedCategories.filter((c) => c.categoryId !== item.categoryId)
      }
    }
  }

  /*
  The `isChecked` function determines whether an item is checked based on its type (product or category).

  1. Returns `true` if the item is checked; otherwise, returns `false`.
  2. Defaults to `false` if the `item` is undefined or null.

  Note: This function currently does not differentiate between types (`product` or `category`) as it only checks the `checked` property.
*/

  isChecked(item: any, _type: 'product' | 'category'): boolean {
    return item?.checked || false
  }

  /**
   * The `loadData()` function retrieves and processes data for products and categories.
   *
   * 1. Fetches the base list of products from `productService`:
   *    - Sets each product's default `checked` to false and `points` to 0.
   *    - If we're editing an existing setup (this.currentSetupId), also fetch the product's
   *      data from /products/<productId>/pointsList/<setupId> to override the default
   *      checked/points values.
   *    - Updates `selectedProductSet` and `selectedProducts.data` accordingly.
   *
   * 2. Fetches the base list of categories from `categoriesService`:
   *    - Sets each category's default `checked` to false and `points` to 0.
   *    - If editing an existing setup, also load the category's
   *      /categories/<categoryId>/pointsList/<setupId> data.
   *    - Updates `selectedCategories` with any categories that end up checked.
   *
   * 3. Handles errors for both product and category fetch operations by logging them to the console.
   */
  loadData(): void {
    // ------------------------------------------------------------------
    // 1. Fetch Products
    // ------------------------------------------------------------------
    this.productService.getProducts('all').subscribe(
      (products: Product[]) => {
        // Initialize products with default checked=false, points=0
        this.products = products.map((p: Product) => ({
          ...p,
          checked: false,
          points: 0
        }))
        this.filteredProducts = [...this.products]
        this.totalProducts = this.productService.totalProductsCount
        // Clear any previously selected products
        this.selectedProductSet.clear()
        this.selectedProducts.data = []
        this.resetPaging()
        this.updateDisplayedProducts()

        // If we're editing an existing setup, load the product's
        // points data from /pointsList/<setupId>.
        if (this.currentSetupId && this.currentSetupId !== ':id') {
          this.loadProductTargets()
        }
      },
      (error) => {
        console.error('Error fetching products:', error)
      }
    )

    // ------------------------------------------------------------------
    // 2. Fetch Categories
    // ------------------------------------------------------------------
    this.categoriesService.getCategories().subscribe(
      (data) => {
        this.categories = data.map((cat: any) => ({
          ...cat,
          checked: false,
          points: 0
        }))
        this.totalCategories = this.categories.length
        this.updateDisplayedCategories()

        // If we're editing an existing setup, load each category's
        // points data from /categories/<categoryId>/pointsList/<setupId>.
        if (this.currentSetupId && this.currentSetupId !== ':id') {
          this.loadCategoryTargets()
        }

        // If you maintain a "selectedCategories" list, update it now
      },
      (error) => {
        console.error('Error fetching categories:', error)
      }
    )
  }

  private loadProductTargets(): void {
    this.pointsService.getPointsSystemTargets(String(this.currentSetupId), 'product')
      .then((data) => {
        const targetMap = new Map<string, { checked: boolean; points: number }>()
        ;(data || []).forEach((row: any) => {
          targetMap.set(String(row.target_id), { checked: !!row.checked, points: row.points || 0 })
        })
        this.products.forEach((product: any) => {
          const entry = targetMap.get(String(product.Id))
          if (entry) {
            product.checked = entry.checked
            product.points = entry.points
            if (product.checked) {
              this.selectedProductSet.add(product)
            }
          }
          this.selectedProducts.data = Array.from(this.selectedProductSet)
        })
      })
      .catch((error) => console.error('Error fetching product targets:', error))
  }

  private loadCategoryTargets(): void {
    this.pointsService.getPointsSystemTargets(String(this.currentSetupId), 'category')
      .then((data) => {
        const targetMap = new Map<string, { checked: boolean; points: number }>()
        ;(data || []).forEach((row: any) => {
          targetMap.set(String(row.target_id), { checked: !!row.checked, points: row.points || 0 })
        })
        this.categories.forEach((cat: any) => {
          const entry = targetMap.get(String(cat.categoryId))
          if (entry) {
            cat.checked = entry.checked
            cat.points = entry.points
          }
        })
        this.selectedCategories = this.categories.filter((cat) => cat.checked)
      })
      .catch((error) => console.error('Error fetching category targets:', error))
  }

  /*
  The `createForm` function initializes the form structure for handling points and product configurations.

  1. Creates a form group named `points` using `FormBuilder`, with the following controls:
     - `currency_category_point`: A field for points related to currency categories.
     - `currency_product_point`: A field for points related to currency products.
     - `currency_system`: A field for specifying the currency system.
     - `enable_points`: A boolean field to enable or disable points.
     - `min_redeem`: A field for specifying the order system.
     - `order_all_products`: A field for specifying order points for all products, with a minimum value validator.
     - `order_cancelation`: A boolean field for order cancellation.
     - `order_checked_cats_points`: A field for points associated with checked categories.
     - `order_checked_products_points`: A field for points associated with checked products.
     - `order_points`: A field for specifying order points, with a minimum value validator.
     - `order_system`: A field for specifying the order system.
     - `points_system`: A field for specifying the points system.
     - `points`: A field for general points, with a minimum value validator.
     - `product_option`: A field for specifying the product option.
     - `product_points`: A field for product points, with a minimum value validator.
     - `products`: A form array for managing a list of products.
     - `redeem_currency`: A field for specifying the order system.
     - `redeem_points`: A field for specifying the order system.
     - `selectedProduct`: A field for managing the selected product.
     - `units`: A field for specifying units, with a minimum value validator.
     - `validity_date: A field for specifying the validity date of the points or offer.
*/

  createForm(): void {
    this.points = this.fb.group({
      appleStore: ['', Validators.required],
      currency_category_point: ['', Validators.required],
      currency_product_point: ['', Validators.required],
      currency_system: ['', Validators.required],
      enable_points: [false],
      id: [''],
      min_redeem: ['', [Validators.required, Validators.min(0)]],
      order_all_products: ['', [Validators.required, Validators.min(0)]],
      order_cancelation: [false],
      order_checked_cats_points: ['', Validators.required],
      order_checked_products_points: ['', Validators.required],
      order_points: ['', [Validators.required, Validators.min(0)]],
      order_system: ['', Validators.required],
      playStore: ['', Validators.required],
      points_system: ['', Validators.required],
      points: ['', [Validators.required, Validators.min(0)]],
      product_option: ['', Validators.required],
      product_points: ['', [Validators.required, Validators.min(0)]],
      products: this.fb.array([]),
      redeem_currency: ['', Validators.required],
      redeem_points: ['', [Validators.required, Validators.min(0)]],
      referral_points: ['', [Validators.required, Validators.min(0)]],
      selectedProduct: ['', Validators.required],
      units: ['', [Validators.required, Validators.min(0)]],
      validity_date: ['', Validators.required]
    })
  }

  /*
  The `getData` function retrieves settings data for points based on the selected project.

  1. Constructs the database path using the `selectedProject` from `builderService` to target the specific settings endpoint.

  2. Fetches data from the database at the constructed path:
     - On successful retrieval, updates the form fields with the fetched data using `updateFormFields`.
     - Logs an error message to the console if the data fetch fails.
*/

  getData(): void {
    this.pointsService.getPointsSetups().subscribe({
      next: (rows) => this.updateFormFields((rows && rows[0]) || {}),
      error: (error) => console.log('Error fetching data', error),
    })
  }

  /*
  The `updateFormFields` function updates the form fields with the provided data.

  1. Uses `patchValue` to update the `points` form group with values from the `data` object:
     - Sets each field to the corresponding value from `data`, or defaults to an empty string or false if the value is not provided.

  2. Ensures that all fields in the form group are populated with either the provided data or default values.
*/

  updateFormFields(data: any): void {
    this.points.patchValue({
      appleStore: data?.apple_store || data?.appleStore || '',
      currency_category_point: data?.currency_category_point || '',
      currency_product_point: data?.currency_product_point || '',
      currency_system: data?.points_system === 'byUnit' ? (data?.sub_mode || '') : '',
      enable_points: data?.enable_points || false,
      min_redeem: data?.min_redeem || '100',
      order_all_products: data?.order_all_products || '',
      order_cancelation: data?.order_cancelation || false,
      order_checked_cats_points: data?.order_checked_cats_points || '',
      order_checked_products_points: data?.order_checked_products_points || '',
      order_points: data?.order_points || '50',
      order_system: data?.points_system === 'byOrder' ? (data?.sub_mode || 'allProductsCategories') : 'allProductsCategories',
      playStore: data?.play_store || data?.playStore || '',
      points_system: data?.points_system || 'byOrder',
      points: data?.points || '',
      product_option: data?.points_system === 'byProductCategory' ? (data?.sub_mode || '') : '',
      product_points: data?.product_points || '',
      redeem_currency: data?.redeem_currency || '10',
      redeem_points: data?.redeem_points || '100',
      referral_points: data?.referral_points || '',
      selectedProduct: data?.selectedProduct || '',
      units: data?.units || '',
      validity_date: data?.validity_date || '30'
    })
  }

  /*
  The `saveChanges` function updates both category and product data in the database, as well as saving valid points data.

1. **Category Updates**:
   - Constructs the base path for categories using the `selectedProject` from `builderService`.
   - Iterates over each category in the `categories` array:
     - For each category:
       - Builds the path to the current category data using `category.categoryId`.
       - Fetches the current category data from the database.
       - Merges the fetched data with the updated fields:
         - Sets `checked` to the category's `checked` value or `false` if not present.
         - Sets `points` to the category's `points` value or `0` if not present.
       - Saves the updated category data back to the database at the constructed path.
       - Logs an error if fetching the current category data fails.

2. **Product Updates**:
   - Constructs the base path for products using the `selectedProject` from `builderService`.
   - Iterates over each product in `dataSource.data`:
     - Maps each product to include its `Id`, `checked`, and `points`:
       - Sets `checked` to the product's `checked` value or `false` if not present.
       - Sets `points` to the product's `points` value or `0` if not present.
     - Builds the path to the current product data using `product.Id`.
     - Fetches the current product data from the database.
     - Merges the fetched product data with the updated fields:
       - Sets `checked` to the product's `checked` value.
       - Sets `points` to the product's `points` value.
     - Saves the updated product data back to the database at the constructed path.
     - Logs an error if fetching the current product data fails.

3. **Points Form Validation and Save**:
   - Iterates over each control in the `points` form group and marks them as touched.
   - Filters out valid form controls, collecting their values into `validPointsData`.
   - If there is any valid points data:
     - Saves it to the database at the `pointsPath`.
   - If no valid points data exists, logs a warning: "No valid points data to save."
*/

  public saveChanges(): void {
    // 1) Validate form controls
    this.validateForm()

    // 3) Gather valid data
    const validPointsData = this.gatherValidFormData()
    if (!validPointsData) {
      console.warn('No valid points data to save.')
      return
    }

    // 4) Save the main points data, then save targets after we have the UUID
    this.saving = true
    this.saveMainPointsData(validPointsData).then((systemId) => {
      if (!systemId) return undefined
      // 5) Update categories, 6) Update products
      return Promise.all([this.updateSelectedCategories(systemId), this.updateSelectedProducts(systemId)])
    }).catch((error) => {
      console.error('Error saving main points data', error)
    }).finally(() => {
      this.saving = false
    })

    if (this.vendor.isMultiVendor) this.vendor.syncSuperVendorSettingsToVendors()
    // 7) Optionally navigate if newly created
    this.navToPoints()
  }

  private validateForm(): void {
    Object.keys(this.points.controls).forEach((key) => {
      const control = this.points.get(key)
      if (control) {
        control.markAsTouched()
      }
    })
  }

  private gatherValidFormData(): { [key: string]: any } | null {
    const fieldsToFloor = ['currency_category_point', 'currency_product_point', 'min_redeem', 'order_all_products', 'order_checked_cats_points', 'order_checked_products_points', 'order_points', 'points', 'product_points', 'redeem_points', 'referral_points', 'units']

    let decimalRemoved = false
    const flooredValuesToPatch: { [key: string]: number } = {}

    const validPointsData = Object.keys(this.points.controls).reduce((acc, key) => {
      const control = this.points.get(key)
      if (control && control.valid) {
        let value = control.value
        if (fieldsToFloor.includes(key) && !isNaN(value)) {
          const floored = Math.floor(Number(value))
          if (floored !== Number(value)) {
            decimalRemoved = true
            flooredValuesToPatch[key] = floored
          }
          value = floored
        }
        acc[key] = value
      }
      return acc
    }, {} as { [key: string]: any })

    // Patch floored values back into the form so user sees the update
    if (Object.keys(flooredValuesToPatch).length > 0) {
      this.points.patchValue(flooredValuesToPatch)
    }

    if (decimalRemoved) {
      alert('Decimal values have been removed and rounded down.')
    }

    return Object.keys(validPointsData).length > 0 ? validPointsData : null
  }

  private async saveMainPointsData(validPointsData: any): Promise<string | null> {
    const pointsSystem = validPointsData.points_system
    let sub_mode: string | null = null
    if (pointsSystem === 'byOrder') sub_mode = validPointsData.order_system || null
    else if (pointsSystem === 'byUnit') sub_mode = validPointsData.currency_system || null
    else if (pointsSystem === 'byProductCategory') sub_mode = validPointsData.product_option || null

    const mainRow: Record<string, any> = {
      project_id: Number(this.project_id),
      enable_points: validPointsData.enable_points ?? false,
      points_system: validPointsData.points_system ?? null,
      sub_mode,
      units: validPointsData.units ?? null,
      points: validPointsData.points ?? null,
      order_points: validPointsData.order_points ?? null,
      order_checked_products_points: validPointsData.order_checked_products_points ?? null,
      order_checked_cats_points: validPointsData.order_checked_cats_points ?? null,
      currency_product_point: validPointsData.currency_product_point ?? null,
      currency_category_point: validPointsData.currency_category_point ?? null,
      product_points: validPointsData.product_points ?? null,
      referral_points: validPointsData.referral_points ?? null,
      play_store: validPointsData.playStore ?? null,
      apple_store: validPointsData.appleStore ?? null,
      redeem_points: validPointsData.redeem_points ?? null,
      redeem_currency: validPointsData.redeem_currency ?? null,
      min_redeem: validPointsData.min_redeem ?? null,
      validity_date: validPointsData.validity_date ?? null,
      order_cancelation: validPointsData.order_cancelation ?? false,
      updated_at: new Date().toISOString()
    }

    const systemId = await this.pointsService.upsertPointsSystem(this.currentSystemUuid || null, mainRow)
    if (!systemId) {
      console.error('Error saving main points data')
      return null
    }
    if (!this.currentSystemUuid) {
      this.currentSystemUuid = systemId
      this.currentSetupId = systemId
    }
    return systemId
  }

  private updateSelectedCategories(systemId: string): Promise<unknown> {
    const targets = this.categories.map((cat: any) => ({
      target_type: 'category' as const,
      target_id: String(cat.categoryId),
      checked: this.selectedCategories.some((selectedCat) => selectedCat.categoryId === cat.categoryId),
      points: cat.points || 0,
    }))
    return this.pointsService.upsertPointsTargets(systemId, targets)
      .catch((error) => console.error('Error saving category targets', error))
  }

  private updateSelectedProducts(systemId: string): Promise<unknown> {
    const targets = (this.products as any[]).map((product) => ({
      target_type: 'product' as const,
      target_id: String(product.Id),
      checked: this.selectedProductSet.has(product),
      points: product.points || 0,
    }))
    return this.pointsService.upsertPointsTargets(systemId, targets)
      .catch((error) => console.error('Error saving product targets', error))
  }

  private navToPoints(): void {
    // If we just created a new setup (no existing ID), navigate away
    if (!this.currentSetupId || this.currentSetupId === ':id') {
      this.router.navigate(['/points'])
    }
  }

  generateUniqueId = () => {
    const timestamp = new Date().getTime().toString()
    const random = Math.floor(Math.random() * 10000).toString()
    return timestamp + '-' + random
  }

  applyFilter() {
    const filterValue = this.searchText.trim().toLowerCase()

    if (!filterValue) {
      this.filteredProducts = [...this.products]
    } else {
      this.filteredProducts = this.products.filter((product) =>
        product.productName?.toLowerCase().includes(filterValue) ||
        product.productSKU?.toLowerCase().includes(filterValue) ||
        product.date?.toLowerCase().includes(filterValue)
      )
    }

    this.totalProducts = this.filteredProducts.length
    this.resetPaging()
    this.updateDisplayedProducts()
  }

  resetPaging() {
    this.pageIndex = 0
    if (this.paginator) {
      this.paginator.pageIndex = 0
    }
  }

  editPoductPoints(element: any) {
    element.editing = true
  }

  stopEdit(element: any) {
    element.editing = false
  }

  /**
   * Updates the displayed products based on the current page.
   */
  updateDisplayedProducts(): void {
    const startIndex = this.pageIndex * this.pageSize
    const endIndex = startIndex + this.pageSize
    this.displayedProducts = this.filteredProducts.slice(startIndex, endIndex)
    this.dataSource.data = this.displayedProducts
  }

  /**
   * Handles page change events from MatPaginator.
   */
  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize
    this.pageIndex = event.pageIndex
    this.updateDisplayedProducts()
  }

  /**
   * Updates the displayed categories based on the current page.
   */
  updateDisplayedCategories(): void {
    const startIndex = this.categoryPageIndex * this.categoryPageSize
    const endIndex = Math.min(startIndex + this.categoryPageSize, this.categories.length)
    this.displayedCategories = this.categories.slice(startIndex, endIndex)
  }

  /**
   * Handles page change events from MatPaginator for categories.
   */
  onCategoryPageChange(event: PageEvent): void {
    this.categoryPageSize = event.pageSize
    this.categoryPageIndex = event.pageIndex
    this.updateDisplayedCategories()
  }
}
